import { Ref } from '@vue/composition-api';
import { useLocalStorage } from '@vueuse/core';

export interface UseStorage {
	get(): string;
	set(value: string): void;
}

export const useStorage = (key: string): UseStorage => {
	const storedKey: Ref<string> = useLocalStorage<string>(key, '');

	function get() {
		const val = storedKey.value;
		return val;
	}

	function set(value: string) {
		storedKey.value = value;
	}

	return {
		get,
		set,
	};
};
